import { t } from 'i18next';

export const RISK_TAB_LABEL = t('Risks');
export const RISK_TAB_ID = 'risks-tab';
export const ALL_CHANGES_TAB_LABEL = t('All Changes');
export const ALL_CHANGES_TAB_ID = 'all-changes-tab';
